<template>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button class="button_back" @click="goBack('userForm')">
                <ion-icon name="arrow-back-outline"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>

    <div class="main_wrapper ion-padding">
        <div class="page_title">Minimum Rate</div>
        <el-form class="full_page" :model="formsData.userForm" :rules="formsData.userForm.rules" :ref="el => formsData.userForm.ref = el" :label-position="'top'" @submit.prevent="submit('userForm')">
            <div class="form_text">
                <div class="title">
                    <span>What is your expected minimum hourly rate (excluding super)</span>
                </div>
            </div>
            <el-form-item prop="minRate" :required='true'>
                <div class="el-input el-input--prefix">
                    <input type="tel" class="input_currency el-input__inner" :ref='el => formsData.userForm.minRate.ref = el' :value="formsData.userForm.minRate.value" :placeholder="'0.00'" v-imask="formsData.userForm.minRate.mask" @accept="($event)=>{onFormMaskAccept($event, 'userForm', 'minRate'); checkFormValidation('userForm', true, 'minRate')}" @blur="checkFormValidation('userForm', true, 'minRate')">
                    <span class="el-input__prefix">$</span>
                </div>
            </el-form-item>
            <el-form-item class="button_submit mb0">
                <el-button class="submit_page" type="blue" @click="submit('userForm')" :disabled="formsData.userForm.disabled">
                    Complete
                </el-button>
            </el-form-item>
        </el-form>
    </div>
</template>


<script>
    import {
        onMounted,
        inject,
    } from 'vue';

    import {
        addIcons
    } from 'ionicons'
    import {
        arrowBackOutline
    } from 'ionicons/icons'
    addIcons({
        'arrow-back-outline': arrowBackOutline
    })
    import {
        IonToolbar,
        IonButton,
        IonButtons,
        IonIcon,
    } from '@ionic/vue';

    import {
        useStore
    } from 'vuex'
    import {
        useRouter,
    } from 'vue-router'
    import formHooks from '@/hooks/form/form'
    import formValidate from '@/hooks/form/validate/validate'
    import formMasks from '@/hooks/form/mask/mask'

    import IMaskDirective from '@/directives/vue-imask/directive';
    import IMask from 'imask/esm/imask';

    export default {
        components: {
            IonToolbar,
            IonButton,
            IonButtons,
            IonIcon,
        },
        directives: {
            imask: IMaskDirective
        },
        setup() {
            const $store = useStore()
            const $router = useRouter()
            const setPageClassGlobal = inject('setPageClassGlobal');

            const userData = $store.getters.GET_USER_DATA;
            const minRate = $store.getters.getJobFilters.minRate || userData.minRate;

            const formsDataArray = {
                userForm: {
                    minRate: {
                        ref: {},
                        value: minRate ? IMask.createMask(formMasks.rate).resolve("" + minRate) : '',
                        mask: formMasks.rate,
                        validators: [{
                            validator: (rule, formField, callback) => {
                                console.log('validate');
                                formValidate.validate(rule, formField, 'minRate', callback, setFormValidation);
                            },
                        }]
                    },
                }
            };

            const goBack = (formName) => {
                $store.dispatch('setJobFiltersData', getFormValues(formName));
                $router.push({
                    name: 'job_filters_days'
                })
            };

            const submit = (formName) => {
                formsRefs[formName].value.validate((valid) => {
                    if (valid) {

                        return (async () => {
                            try {
                                $store.dispatch('setJobFiltersData', getFormValues(formName));
                                await $store.dispatch('SAVE_USER_DATA', $store.getters.getJobFilters);
                                goNext();
                            } catch (error) {
                                console.log(error);
                            }
                        })();
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            };

            const goNext = () => {
                $router.push({
                    name: 'search',
                })
            };

            onMounted(() => {
                setPageClassGlobal('global_job_filters_page');
                setFormRefs();
                formsRefs.userForm.value.$el[0].focus();
                checkFormValidation('userForm', false);
            });

            const {
                onFormMaskAccept,
                checkFormValidation,
                setFormValidation,
                getFormValues,
                setFormRefs,
                formsData,
                formsRefs,
            } = formHooks(formsDataArray);

            return {
                formsData,
                onFormMaskAccept,
                checkFormValidation,
                goBack,
                submit,
            }
        },
    }
</script>